let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1mTou")).then(() => parcelRequire('858UZ'));